import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AgoraVideoCall from './AgoraService';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Default route - redirect to join form */}
        <Route path="/" element={<AgoraVideoCall />} />
        
        <Route path="/session/:roomId" element={<AgoraVideoCall />} />
        {/* Compatibility route for links issued before the Mentorzaa migration. */}
        <Route path="/room/:roomId" element={<AgoraVideoCall />} />
        
        {/* Channel route - alternative routing */}
        <Route path="/channel/:channel" element={<AgoraVideoCall />} />
        
        {/* Handle all other routes - redirect to home */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
